import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi } from '../../api/configuration';

export function PreferencesCenterPage() {
  const [theme, setTheme] = useState('system');
  const [density, setDensity] = useState('comfortable');
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    void configurationApi.listPreferences().then(() => {}).catch((e) => setError(String(e)));
  }, []);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    try {
      await configurationApi.updatePreferences({
        category: 'theme',
        values: { 'theme.mode': theme, 'theme.density': density },
      });
      setSaved(true);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Preferences Center</h1>
      <form onSubmit={(e) => void handleSave(e)} className="mt-6 space-y-4">
        <label className="block">
          <span className="text-sm">Theme mode</span>
          <select value={theme} onChange={(e) => setTheme(e.target.value)} className="mt-1 w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900">
            <option value="system">System</option>
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </label>
        <label className="block">
          <span className="text-sm">Density</span>
          <select value={density} onChange={(e) => setDensity(e.target.value)} className="mt-1 w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900">
            <option value="comfortable">Comfortable</option>
            <option value="compact">Compact</option>
          </select>
        </label>
        <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white">Save preferences</button>
      </form>
      {saved && <p className="mt-4 text-sm text-green-600">Preferences saved.</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
